import styled from 'styled-components'

export const FieldWrapper = styled.div`
  gap: 16px;
  display: flex;
  align-items: end;
  margin-top: 12px;

  > div {
    flex: 1;
  }

  .location-select-wrapper {
    margin-top: 0;
  }

  > svg {
    align-self: center;
  }
`
